/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxmUserauthV1OrganizationState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXM_USERAUTH_V1_ORGANIZATION_STATE_ENTITY_NAME = 'ixm.userauth.v1.Organization';
export const ixmUserauthV1OrganizationStateEntity = new schema.Entity<IxmUserauthV1OrganizationState>(IXM_USERAUTH_V1_ORGANIZATION_STATE_ENTITY_NAME, {}, { idAttribute: 'organizationId' });

